export default function LinePrimitive(overlay, ctx, layout, candles) {
    
    if (candles.length < 2) return
    
    ctx.strokeStyle = overlay.lineColor
    ctx.lineWidth = overlay.lineWidth
    ctx.lineCap = 'round'
    ctx.lineJoin = 'round'
    
    ctx.beginPath()
    
    // Start from the first candle
    let firstCandle = candles[0]
    ctx.moveTo(layout.t2screen(firstCandle.raw[0]), layout.$2screen(firstCandle.raw[4]))
    
    // Draw line through all candle close prices
    for (let i = 1; i < candles.length; i++) {
        let candle = candles[i]
        ctx.lineTo(layout.t2screen(candle.raw[0]), layout.$2screen(candle.raw[4]))
    }
    
    ctx.stroke()
}
